// product-showcase.js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.psw').forEach(initShowcase);
});

function initShowcase(root) {
  // swatch click: swap image/price/variant for that card
  root.querySelectorAll('.psw__card').forEach(card => {
    const swatches = card.querySelectorAll('.psw__swatch');
    const img = card.querySelector('.psw__image');
    const price = card.querySelector('.psw__price');
    const quickAdd = card.querySelector('.psw__quick-add');

    swatches.forEach(sw => {
      sw.addEventListener('click', (e) => {
        e.preventDefault();
        swatches.forEach(s => s.classList.remove('psw__swatch--selected'));
        sw.classList.add('psw__swatch--selected');
        if (img && sw.dataset.image) img.src = sw.dataset.image;
        if (price && sw.dataset.price) price.textContent = sw.dataset.price;
        if (quickAdd) quickAdd.dataset.variantId = sw.dataset.variantId;
      });
    });
  });

  // color filter pills
  const pills = root.querySelectorAll('.psw__filter-pill');
  const cards = root.querySelectorAll('.psw__card');
  let activeFilter = null;

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      const value = pill.dataset.colorFilter;
      if (activeFilter === value) {
        activeFilter = null;
        pills.forEach(p => p.classList.remove('psw__filter-pill--active'));
        cards.forEach(c => { c.hidden = false; });
        return;
      }
      activeFilter = value;
      pills.forEach(p => p.classList.toggle('psw__filter-pill--active', p === pill));
      cards.forEach(c => {
        const colors = c.dataset.colors || '';
        c.hidden = !colors.includes(value);
      });
    });
  });

  // quick add
  root.querySelectorAll('.psw__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      btn.disabled = true;
      const original = btn.textContent;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        btn.textContent = '✓ Added';
        if (window.BPSCart && typeof window.BPSCart.open === 'function') {
          window.BPSCart.open();
        } else if (window.BPSCart && typeof window.BPSCart.refresh === 'function') {
          window.BPSCart.refresh();
        }
      } catch (err) {
        console.error('Product Showcase: add to cart failed', err);
        btn.textContent = 'Error';
      } finally {
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1800);
      }
    });
  });
}
